// Lazysizes
import 'lazysizes';

import Alpine from 'alpinejs'
import ui from "@alpinejs/ui";
import collapse from '@alpinejs/collapse'
import focus from "@alpinejs/focus";
import mask from '@alpinejs/mask'
import persist from '@alpinejs/persist'
import "./components/zenscroll";

import { tns } from "./../../node_modules/tiny-slider/src/tiny-slider";
window.tns = tns;

import Cookies from "js-cookie";
window.Cookies = Cookies;

import { saveAs } from "file-saver";
window.saveAs = saveAs;

window.Alpine = Alpine
Alpine.plugin(ui)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(mask)
Alpine.plugin(persist)
Alpine.start()

window.getVerificationToken = () => ({
    'RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
});

// aspnet-client-validation bootup
import { ValidationService } from 'aspnet-client-validation'
let v = new ValidationService()
v.bootstrap()

window.v = v
